export default Object.freeze({
  One: 'one',
  All: 'all',
  Custom: 'custom',
});
